import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight, MapPin } from "lucide-react";
import { IMAGES } from "../lib/funnelData";
import { Testimonials } from "./Testimonials";

export const Hero = ({ p, onStart }) => {
  const [address, setAddress] = useState("");

  return (
    <section id="top">
      <div className="relative min-h-[88vh] flex items-center overflow-hidden bg-emeraldx-deeper">
        <video
          autoPlay muted loop playsInline
          poster={IMAGES.heroPoster}
          className="absolute inset-0 w-full h-full object-cover hero-zoom"
          data-testid="hero-video"
        >
          <source src={IMAGES.heroVideoWebm} type="video/webm" />
          <source src={IMAGES.heroVideoMp4} type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/40 to-black/70" />
        <div className="overlay-grain" />
        <div className="relative w-full max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-24 text-center">
          <motion.img
            src={IMAGES.logoWhite}
            alt="Cann Realty LLC"
            data-testid="hero-logo"
            className="h-14 sm:h-20 w-auto mx-auto"
            initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}
          />
          <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4, delay: 0.1 }}>
            <span data-testid="hero-badge" className="badge-brand-light mt-6">{p.badge}</span>
          </motion.div>
          <motion.h1
            data-testid="hero-headline"
            className="mt-6 text-3xl sm:text-4xl lg:text-5xl font-serif text-white leading-[1.2] [text-wrap:balance]"
            initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4, delay: 0.2 }}
          >
            {p.headline}
          </motion.h1>
          <motion.p
            data-testid="hero-subheadline"
            className="mt-5 text-base sm:text-lg text-stone-300 leading-relaxed max-w-2xl mx-auto [text-wrap:pretty]"
            initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4, delay: 0.3 }}
          >
            {p.subheadline}
          </motion.p>
          <motion.form
            className="mt-8 flex flex-col sm:flex-row gap-3 max-w-xl mx-auto"
            initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4, delay: 0.4 }}
            onSubmit={(e) => { e.preventDefault(); onStart(address); }}
          >
            <label htmlFor="hero-address" className="sr-only">Property address</label>
            <div className="relative flex-1">
              <MapPin size={18} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-stone-400" />
              <input
                id="hero-address"
                data-testid="hero-address-input"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                placeholder="Enter your property address"
                className="w-full rounded-full bg-white/95 pl-10 pr-4 py-3.5 text-base text-stone-800 placeholder:text-stone-400 focus:outline-none focus:ring-2 focus:ring-oak/60 transition-shadow duration-150"
              />
            </div>
            <button
              type="submit"
              data-testid="hero-start-funnel-button"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-oak hover:bg-oak-dark text-white px-7 py-3.5 text-xs font-semibold uppercase tracking-[0.15em] transition-colors duration-150 active:scale-[0.96] whitespace-nowrap"
            >
              Value My Property <ArrowRight size={16} />
            </button>
          </motion.form>
          <motion.div
            className="mt-10"
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5, delay: 0.55 }}
            data-testid="hero-review"
          >
            <Testimonials />
          </motion.div>
        </div>
      </div>
    </section>
  );
};
